
// The dialog itself is excluded from the Sprig swap (the form/Clear button
// target #case-filtering only), so it's the same DOM node for the page's
// whole lifetime. Bind its controls once, guarded by a data attribute,
// since caseFilters() re-runs on every swap to rebind the open-filter
// trigger button (which does get recreated, living inside #case-filtering).
const bindDialogControls = (target) => {
    if (target.dataset.filtersBound) {
        return;
    }

    target.dataset.filtersBound = 'true';

    const closeB = target.querySelector('[data-close]');
    const applyB = target.querySelector('[data-apply]');

    closeB.addEventListener('click', function(e) {
        e.preventDefault();
        closeCaseFilters(target);
    });

    applyB.addEventListener('click', function() {
        closeCaseFilters(target);
    });

    target.addEventListener('click', function(e) {
        if (!e.target.closest('.dialog-inner')) {
            closeCaseFilters(target);
        }
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && target.classList.contains('is-open')) {
            closeCaseFilters(target);
        }
    });
}

const caseFilters = () => {

    let openBtns = document.querySelectorAll('[data-open-filter]');

    openBtns.forEach(function(button) {
        const targetId = button.getAttribute('data-open-filter');
        const target = document.getElementById(targetId);

        if (!target) {
            return;
        }

        button.addEventListener('click', function(e) {
            e.preventDefault();
            target.classList.add('is-open');
        });

        bindDialogControls(target);
    });

}

const closeCaseFilters = (target) => {
    target = target || document.getElementById('case-filters-dialog');

    if (!target) {
        return;
    }

    target.classList.add('closing');
    setTimeout(function() {
        target.classList.remove('closing');
        target.classList.remove('is-open');
    }, 600);
}

// Sprig re-renders #case-filtering's data attributes with the current
// selection on every swap, so reading from there (rather than the
// checkboxes) always reflects what the server just applied.
const updateFilterUrl = () => {
    const container = document.getElementById('case-filtering');

    if (!container) {
        return;
    }

    const services = container.dataset.selectedServices;
    const industries = container.dataset.selectedIndustries;

    // Built manually rather than via URLSearchParams, which percent-encodes
    // commas (%2C) - we want them literal in the address bar.
    const params = [];

    if (services) {
        params.push('services=' + services);
    }

    if (industries) {
        params.push('industries=' + industries);
    }

    const query = params.length ? '?' + params.join('&') : '';
    const url = window.location.pathname + query + window.location.hash;

    history.replaceState(null, '', url);
}

// Card tag-pills (marked data-scroll-to-results) smooth-scroll back up to the
// results once they've swapped in. Done here rather than with htmx's
// `show:` swap modifier, since that always uses the global
// htmx.config.scrollBehavior ('instant') and can't be made smooth per-request.
const scrollToResults = (event) => {
    const trigger = event && event.detail && event.detail.requestConfig && event.detail.requestConfig.elt;

    if (!trigger || !trigger.hasAttribute('data-scroll-to-results')) {
        return;
    }

    const container = document.getElementById('case-filtering');

    if (!container) {
        return;
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // scroll-mt on #case-filtering keeps it clear of the fixed header
    container.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
}

window.__caseFilters = caseFilters;
window.__scrollToResults = scrollToResults;
window.__closeCaseFilters = closeCaseFilters;
window.__updateFilterUrl = updateFilterUrl;

// Use DOMContentLoaded to ensure the CMS has rendered the elements 
// before we try to observe them.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', caseFilters);
} else {
  caseFilters();
}


// WEBPACK FOOTER //
// ./source/scripts/sections/filters.js